import { newAPI } from '../../../services';
import qs from 'qs';

export const fetchSuperlogicaList = async userId => {
  const response = await newAPI.get(`${userId}/superlogica/clients`);
  return response.data;
}

export const createNewEstablishment = async params => {
  const response = await newAPI.post(`${params?.userId}/establishment/new-unit`, qs.stringify(params));
  return response.data;
}